import AdminLayout from "components/layouts/AdminLayout";
import SingleLoanViewLayout from "components/tenders/singleLoan/SingleLoanViewLayout";
import { useParams } from 'react-router';
import { FaArrowLeft } from "react-icons/fa";
import { TranslateString } from "Utils/Common";
import { Card, Spin } from "antd";
import { useState, useEffect } from "react";
import LoanOfferComparison from "components/tenders/singleLoan/LoanOfferComparison";
import SingleLoanServices from "services/services/SingleLoanServices";
import { Link } from "react-router-dom";
var htmlPdfClient = require("html-pdf-client")

function SingleLoanView2(props: any) {
    const id = useParams();
    const [btnClick, setBtnClick] = useState<any>(1);
    const [loading, setLoading] = useState(false);
    const [loanData, setLoanData] = useState<any>();
    const [showPrintBtn, setPrintShowBtn] = useState(false);
    const [headerText, setHeaderText] = useState('');
    const [printBtn, setPrintBtn] = useState(false);

    const print = async () => {
        var element: any = document.getElementById('loan-offer-comparison');
        setPrintBtn(true);
        var opt = {
            margin: 0.1,
            filename: 'Lainavertailu '+ headerText + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'A4', orientation: 'landscape', compressPDF: true },
            pagebreak: { mode: 'avoid-all', before: '.page-break' }
        };
        setPrintShowBtn(true);
        // New Promise-based usage:
        await htmlPdfClient().set(opt).from(element).save();
        setPrintBtn(false);
        setPrintShowBtn(false);
    }

    useEffect(() => {
        getLoanData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getLoanData = () => {
        setLoading(true);
        let paramsId = id.loan_tender_id
        SingleLoanServices
        .getSingleLoanData(paramsId)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                const responseVal = response?.data?.data
                setHeaderText(responseVal.LOAN_DATA.loan_data_customername.trim() + ', ' +responseVal.LOAN_DATA.loan_data_name.trim())
                setLoanData(responseVal)
                if(responseVal?.dynamics_ticket_number_offer){
                    setBtnClick(2)
                }
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    };

    return (
        <AdminLayout>
            <Spin spinning={loading} >
                <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left cu-tab-text">
                    <h4 className="cu-m-0 cu-p-0">
                        <button className="ant-btn cu-border-0 back-btn text-primary"><FaArrowLeft style={{ fontWeight: 900, fontSize: '18px' }} /></button>
                        &nbsp;
                        {btnClick === 2 ? <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">{TranslateString('loan_comparison')}: {headerText}</button>:
                        btnClick === 1 && <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">{TranslateString('single_loan_view_for_housing_manager')}</button> }
                    </h4>
                </div>
                <Card className="cu-table-small cu-card-padding">
                    <div className="d-flex flex-row justify-content-start">
                        <button onClick={() => { setBtnClick(1) }} className={btnClick === 1 ? "btn btn-sm cu-btn-green mr-3 cu-btn-sm-with" : "btn btn-sm cu-btn-green mr-3 opacity-25 cu-btn-sm-with"}>{TranslateString('tender_details')}</button> 
                        <button onClick={() => { setBtnClick(2) }} disabled={ loanData?.dynamics_ticket_number_offer === null ? true : false} className={btnClick === 2 ? "btn btn-sm cu-btn-green cu-btn-sm-with" : "btn btn-sm cu-btn-green mr-3 opacity-25 cu-btn-sm-with"}>{TranslateString('loan_comparison')}</button>
                        
                        <div className="ms-auto">
                            {btnClick === 2 && <>
                                    <button onClick={() => { print(); }} className={"btn btn-sm cu-btn-green cu-btn-md-with"}>{TranslateString('export_loan_comparison')}</button>&nbsp;
                                    <Link to={'/generate-pdf/' + id?.id + '/'+loanData?.LOAN_DATA?.loan_data_id} target="_blank" className="btn btn-sm cu-btn-green cu-btn-md-with">
                                        <span className="cu-m-0 cu-p-0 text-white text-nowrap">
                                            {TranslateString('Export Ador Analysis')}
                                        </span>
                                    </Link>
                                </>
                            }
                        </div>
                    </div>
                    {btnClick === 1 &&
                        <SingleLoanViewLayout {
                            ...{ ...props, ...id }}
                            type={`manager`}
                        />}
                    {btnClick === 2 && <div id="loan-offer-comparison"><LoanOfferComparison {...{ ...props, ...id }} printBtn={printBtn} printShow={showPrintBtn} headerText={headerText}/></div>}
                </Card>
            </Spin>
        </AdminLayout>
    );
}

export default SingleLoanView2;